module.exports = __webpack_public_path__ + "media/images/gifts/light/sug_luz_1-3cd371979ce7fa21ee4c3e9b6bcd55db.jpg";